<template>
  <v-container grid-list-xs class="pa-0">
    <v-layout row wrap>
      <v-flex xs12>
        <PC-Table
          name="Pools"
          :headers="headers"
          :items="pools"
          @edit="edit"
          @remove="remove"
        >
          <template v-slot:in-title>
            <PC-Dialog
              type="Pool"
              label="Pool Type"
              :showDialog="showDialog"
              :fields="fields"
              @close="close"
              @create="create"
              @save="save"
            >
              <template v-slot:button>
                <v-btn
                  small
                  absolute
                  bottom
                  left
                  fab
                  color="green"
                  dark
                  @click="create"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
            </PC-Dialog>
          </template>
        </PC-Table>
      </v-flex>
    </v-layout>
    <AdView id="165" />
    <PCModal />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import firebase from "@/firebase";
import AdView from "@/components/AdView";
import PCDialog from "@/components/PCDialog";
import PCModal from "@/components/PCModal";
import PCTable from "@/components/PCTable";

export default {
  components: { AdView, PCDialog, PCModal, PCTable },
  data() {
    return {
      editID: 1,
      newRecord: false,
      showDialog: false,
      fields: [
        {
          name: "Name",
          type: "text",
          value: "",
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "Type",
          type: "select",
          value: "",
          items: ["Pool", "Hot Tub"],
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "Pool Surface",
          type: "select",
          value: "",
          items: ["Plaster", "Vinyl", "Fiberglass"],
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "Units",
          type: "select",
          value: "",
          items: ["U.S.", "Metric", "Imperial"],
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "Volume",
          type: "text",
          value: "",
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "Advanced (optional):",
          type: "label",
          classes: ["xs12"],
        },
        {
          name: "Sanitizer (FC)",
          type: "select",
          value: "",
          items: [],
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "pH Raise",
          type: "select",
          value: "",
          items: [],
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "pH Lower",
          type: "select",
          value: "",
          items: [],
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "CH Raise",
          type: "select",
          value: "",
          items: [],
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "Stabilizer (CYA)",
          type: "select",
          value: "",
          items: [],
          classes: ["pa-2", "xs12", "md6"],
        },
        {
          name: "Borate",
          type: "select",
          value: "",
          items: [],
          classes: ["pa-2", "xs12", "md6"],
        },
      ],
      headers: [
        { text: "Name", align: "left", value: "name" },
        { text: "Type", align: "left", value: "type" },
        { text: "Surface", align: "left", value: "surface" },
        { text: "Units", align: "left", value: "units" },
        { text: "Volume", align: "left", value: "volume" },
        { text: "FC", align: "left", value: "fc" },
        { text: "pH Raise", align: "left", value: "phRaise" },
        { text: "pH Lower", align: "left", value: "phLower" },
        { text: "CH", align: "left", value: "ch" },
        { text: "CYA", align: "left", value: "cya" },
        { text: "Borate", align: "left", value: "borate" },
        { text: "Actions", align: "left", value: "actions" },
      ],
      pools: [],
    };
  },
  computed: {
    ...mapGetters({
      borate: "borate/getBorate",
      ch: "ch/getCH",
      cya: "cya/getCYA",
      fc: "fc/getFC",
      ph: "ph/getPH",
      settings: "settings/getSettings",
      user: "user/getUser",
    }),
    poolsRef() {
      return firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("pools");
    },
  },
  methods: {
    ...mapActions({
      saveSettings: "settings/saveSettings",
    }),
    close() {
      this.fields.forEach((field) => (field.value = ""));
      this.showDialog = false;
    },
    create() {
      if (!this.user.premium && this.pools.length >= 1) {
        this.$router.push({ name: "account.billing" });
        return;
      }

      this.newRecord = true;
      this.showDialog = true;
    },
    async edit(id) {
      this.newRecord = false;
      this.editID = id;
      const pool = await this.poolsRef.doc(id).get();
      const data = pool.data();
      this.fields[0].value = data.name;
      this.fields[1].value = data.type;
      this.fields[2].value = data.surface;
      this.fields[3].value = data.units;
      this.fields[4].value = data.volume;
      this.fields[6].value = data.fc;
      this.fields[7].value = data.phRaise;
      this.fields[8].value = data.phLower;
      this.fields[9].value = data.ch;
      this.fields[10].value = data.cya;
      this.fields[11].value = data.borate;
      this.showDialog = true;
    },
    async remove(id) {
      if (
        this.settings.pool.name ===
        this.pools.find((pool) => pool.id === id).name
      ) {
        this.settings.pool = {};
      }
      await this.poolsRef.doc(id).delete();
      await this.updatePools();
      this.settings.pools = this.pools;
      await this.saveSettings(this.settings);
    },
    async save() {
      const data = {
        name: this.fields[0].value || "",
        type: this.fields[1].value || "",
        surface: this.fields[2].value || "",
        units: this.fields[3].value || "",
        volume: Number(this.fields[4].value) || "",
        fc: this.fields[6].value || "",
        phRaise: this.fields[7].value || "",
        phLower: this.fields[8].value || "",
        ch: this.fields[9].value || "",
        cya: this.fields[10].value || "",
        borate: this.fields[11].value || "",
      };
      if (this.newRecord) {
        await this.poolsRef.add(data);
      } else {
        await this.poolsRef.doc(this.editID).set(data);
      }
      this.settings.pool = data;
      await this.saveSettings(this.settings);
      await this.updatePools();
      this.fields.forEach((field) => (field.value = ""));
      this.showDialog = false;
    },
    pushPool(pool) {
      const data = pool.data();
      this.pools.push({
        id: pool.id,
        name: data.name,
        type: data.type,
        surface: data.surface,
        units: data.units,
        volume: data.volume,
        fc: data.fc,
        phRaise: data.phRaise,
        phLower: data.phLower,
        ch: data.ch,
        cya: data.cya,
        borate: data.borate,
      });
    },
    async updatePools() {
      this.pools = [];
      const pools = await this.poolsRef.get();
      pools.forEach((pool) => this.pushPool(pool));
    },
  },
  async mounted() {
    this.fields[6].items = this.fc.types;
    this.fields[7].items = this.ph.raiseTypes;
    this.fields[8].items = this.ph.lowerTypes;
    this.fields[9].items = this.ch.types;
    this.fields[10].items = this.cya.types;
    this.fields[11].items = this.borate.types;
    await this.updatePools();
  },
};
</script>
